import { ComponentProps, useContext } from 'react';
import { RequiredFields } from '../@types/utils';
import ModalContext from '../contexts/ModalContext';
import { useTranslation } from 'react-i18next';
import { App } from '../pages/material/api/appsApi';
import Dialog from '@pelckmans/elementis/components/dialog';
import Button from '@pelckmans/elementis/components/button';

type Props = {
  id: string;
  app: RequiredFields<App, 'platformUrl'>;
};

export default function AppModal({ id, app }: Props) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  const handleClose = () => {
    closeModal(id);
  };

  const size: ComponentProps<typeof Dialog>['size'] = 'full';

  return (
    <Dialog
      id={id}
      modal
      size={size}
      onClose={handleClose}
      className="material-dialog"
      aria-label="SHARED_COMPONENTS.APP_MODALS.A11Y_LABEL"
    >
      <Dialog.Header
        title={app.name}
        onClose={handleClose}
        aria-label={t('ACTIONS.CLOSE')}
        showCloseLabelAsText={size === 'full'}
        buttonGroupProps={
          app.allowedToOpenInNewTab
            ? {
                'aria-label': undefined,
                role: undefined,
                children: (
                  <Button
                    prominence="neutral"
                    aria-label={t('SHARED_COMPONENTS.APP_MODALS.ACTIONS.NEW_TAB')}
                    as="link"
                    href={app.platformUrl}
                    target="_blank"
                  >
                    {t('SHARED_COMPONENTS.APP_MODALS.ACTIONS.NEW_TAB')}
                  </Button>
                ),
              }
            : undefined
        }
      />
      <Dialog.Body>
        <iframe role="presentation" height="100%" src={app.platformUrl} title={app.name} frameBorder="0" />
      </Dialog.Body>
    </Dialog>
  );
}
